/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Mark_Shipped_FailedInputs */

const en_samples_edit_mark_shipped_failed = /** @type {(inputs: Samples_Edit_Mark_Shipped_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to mark sample as shipped`)
};

const es_samples_edit_mark_shipped_failed = /** @type {(inputs: Samples_Edit_Mark_Shipped_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al marcar muestra como enviada`)
};

/**
* | output |
* | --- |
* | "Failed to mark sample as shipped" |
*
* @param {Samples_Edit_Mark_Shipped_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_mark_shipped_failed = /** @type {((inputs?: Samples_Edit_Mark_Shipped_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Mark_Shipped_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_mark_shipped_failed(inputs)
	return es_samples_edit_mark_shipped_failed(inputs)
});